/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import { ColorPicker as KendoColorPicker } from '@progress/kendo-react-inputs';
import './ColorPickerStyles.scss';
// Utility function to convert RGBA to hex
const rgbaToHex = (rgba) => {
    // Parse RGBA string like "rgba(245, 177, 131, 1)"
    const rgbaMatch = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
    if (!rgbaMatch) {
        // If it's already a hex value or invalid format, return as is
        return rgba;
    }
    const r = parseInt(rgbaMatch[1], 10);
    const g = parseInt(rgbaMatch[2], 10);
    const b = parseInt(rgbaMatch[3], 10);
    // Convert to hex
    const toHex = (n) => {
        const hex = n.toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
const ColorPicker = forwardRef(({ value, defaultValue = '#3366cc', onChange, onBlur, label, error, required = false, disabled = false, className = '', name, id }, ref) => {
    const handleColorChange = (event) => {
        if (onChange) {
            // Convert the color value to hex before passing to onChange
            const hexValue = rgbaToHex(event.value);
            // Create a new event object with the hex value
            const modifiedEvent = Object.assign(Object.assign({}, event), { value: hexValue });
            onChange(modifiedEvent);
        }
    };
    const colorValue = value || defaultValue;
    return (React.createElement("div", { className: `color-picker-wrapper ${className}` },
        label && (React.createElement("label", { htmlFor: id || name, className: "color-picker-label" },
            label,
            required && React.createElement("span", { className: "required-asterisk" }, " *"))),
        React.createElement("div", { className: "color-picker-container" },
            React.createElement(KendoColorPicker, { ref: ref, view: "gradient", value: colorValue, onChange: handleColorChange, onBlur: onBlur, disabled: disabled, className: `color-picker-input ${error ? 'has-error' : ''}` })),
        error && React.createElement("div", { className: "color-picker-error" }, error)));
});
ColorPicker.displayName = 'ColorPicker';
export default ColorPicker;
